import { Text } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React from 'react';

import { ThemePublicationHeader } from '../headers/ThemePublicationHeader';
import * as S from './styled';

const BaseMetaBlock = ({
  publicationDate,
  duration,
  categories,
  subThemes,
  viewCount,
  children,
}) => {
  const showCategories = categories && categories.length !== 0;

  return (
    <S.BaseMetaBlockDataContainer>
      <S.DateTimeContainer>
        <S.Row>
          {subThemes && (
            <>
              <ThemePublicationHeader subThemes={subThemes} />
              <span>&nbsp; &bull; &nbsp;</span>
            </>
          )}

          {showCategories && (
            <>
              <S.CategoryContainer>{categories}</S.CategoryContainer>
              <span>&nbsp; &bull; &nbsp;</span>
            </>
          )}
          <Text>{publicationDate}</Text>
          {duration && (
            <>
              <span>&nbsp; &bull; &nbsp;</span>
              <Text>{duration}</Text>
              <S.Dot>&nbsp; &bull; &nbsp;</S.Dot>
            </>
          )}
        </S.Row>
        <S.Row>
          {viewCount >= 50 && (
            <>
              <Text>{viewCount} keer bekeken</Text>
              <span>&nbsp; &bull; &nbsp;</span>
            </>
          )}
          {children}
        </S.Row>
      </S.DateTimeContainer>
    </S.BaseMetaBlockDataContainer>
  );
};

BaseMetaBlock.defaultProps = {
  duration: null,
  categories: null,
  viewCount: 0,
};

BaseMetaBlock.propTypes = {
  publicationDate: PropTypes.string.isRequired,
  duration: PropTypes.string,
  categories: PropTypes.node,
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  viewCount: PropTypes.number,
  children: PropTypes.node,
};

export { BaseMetaBlock };
